import { Typography } from "@mui/material";
import React from "react";
import FormNumber from "./FormNumber";

const UpdateNumber = ({ handleToggle, number }) => {
  return (
    <>
      <Typography variant="Poster" component="h4" gutterBottom>
        Update the phone number for this WhatsApp account.
      </Typography>
      <FormNumber handleSuccess={handleToggle} number={number} />
    </>
  );
};

export default UpdateNumber;
